export const Logout = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="logout"
  >
    <path d="M15 8.00006H7.6958" stroke="#F04B35" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12.5649 10.4348L14.9997 8.00003L12.5649 5.56531"
      stroke="#F04B35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.47852 2.21759H11.0436C11.2141 2.21759 11.348 2.3515 11.348 2.52193V4.04363"
      stroke="#F04B35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.348 11.9565V13.4782C11.348 13.6486 11.2141 13.7825 11.0436 13.7825H6.47852"
      stroke="#F04B35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.00049 13.6121C1.00049 13.7521 1.09788 13.8799 1.23787 13.9103L6.10733 14.9938C6.19863 15.0121 6.28993 14.9938 6.36297 14.9329C6.43601 14.8782 6.47862 14.7868 6.47862 14.6955V1.30455C6.47862 1.21325 6.43601 1.12804 6.36297 1.06717C6.28993 1.01239 6.19863 0.98804 6.10733 1.0063L1.23787 2.08975C1.09788 2.12019 1.00049 2.24192 1.00049 2.38801V13.6121Z"
      stroke="#F04B35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.34808 8.91308C4.85329 8.91308 5.2611 8.50526 5.2611 8.00006C5.2611 7.49485 4.85329 7.08704 4.34808 7.08704C3.84288 7.08704 3.43506 7.49485 3.43506 8.00006C3.43506 8.50526 3.84288 8.91308 4.34808 8.91308Z"
      stroke="#F04B35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
